


export const SHORT_TASK_ZX = [
    {
        id: 1,
        type: '選擇題',
        text: '1.<br/>晴蓉剛上課時，看見自己課本上黏 了張便條紙，內容提及她最近剛好 想去體驗的實境遊戲題材，她好想答應邀約，可是便條紙內容卻不夠清楚，讓她無法做出決定。<br/><img src="/secondary/tasks/tt1.png" alt="便條紙">',
        question: '請問便條紙中只清楚呈現出哪一個訊息？',
        options: [
            { text: 'A. 預計體驗的日期', },
            { text: 'B. 預計體驗的時間', },
            { text: 'C. 預計體驗的遊戲', correct: true },
            { text: 'D. 預計邀約的人數', },
        ],
        background: '#F8FAFB',
    }, {
        id: 2,
        type: '選擇題',
        text: '2.<br/>「對我而言，哲學課的目標在於能達到讓學生去反思問題，甚至打破既有的想法，能開始質疑他過去所接受的觀點或訊息。」',
        question: '這句話的涵義，與下列何者最接近？',
        options: [
            { text: 'A. 哲學的目的是為了否定過去所學。', },
            { text: 'B. 學習哲學是為了不斷對話及提問。', },
            { text: 'C. 哲學的訓練是為了打破既有框架。', correct: true },
            { text: 'D. 反思問題是哲學課程的唯一途徑。', },
        ],
        
         background: '#F8FAFB'

    }, {
        id: 3,
        type: '選擇題',
        text: '3.<br/>「□□□不只引領人類找出解決技術與科技問題的革新辦法，同時也為我們展開了各種可能性，改善真實生活中的惱人困擾。□□□並不是清晰判斷力的敵人，反而是理性的夥伴，它為現實帶來嶄新的光芒與靈性願景，這些正是我們消費至上的社會所欠缺的。」',
        question: '根據文意脈絡，□□□最可能是下列哪一項基本能力？',
        options: [
            { text: 'A. 想像力', correct: true },
            { text: 'B. 記憶力' },
            { text: 'C. 感受力' },
            { text: 'D. 觀察力' },
        ],
        background: '#F8FAFB',
    }, {
        id: 4,
        type: '選擇題',
        text: '4.<br/>「那片靜謐的湖泊位在山坳處。據導遊說，是為了紀念古老的傳說，才取了如此夢幻空靈的名字。更重要的是，湖水澄澈。這年我十歲，湖面平靜得像是一面巨大的明鏡。記憶裏我從未見過湖底的淤泥，湖水不是輕撫著岸邊的鵝卵石，就是溫柔地映照著連綿的雲朵，要不就綢緞般地滑過石縫，甚美。在我眼裏，它簡直是一座宮殿。多年後，我在畫廊看到這張油畫，那時，這座湖已乾涸十年了。」 ',
        question: '依照上文內容，下列文句，何者屬於「客觀性」的敘述？',
        options: [
            { text: 'A. 湖水不是輕撫著岸邊的鵝卵石，就是溫柔地映照著連綿的雲朵。' },
            { text: 'B. 記憶裡我從未見過湖底的淤泥，湖水綢緞般地滑過石縫，甚美。' },
            { text: 'C. 那片靜謐的湖泊位在山坳處，湖面平靜得像是一面巨大的明鏡。' },
            { text: 'D. 多年後，我在畫廊看到這張油畫，那時，這座湖已乾涸十年了。', correct: true }
        ],
        
          background: '#F8FAFB'
    },
     {
        id: 5,
        type: '選擇題',
        text: '5.<br/>「生茄子嘗起來就像一顆平淡無味的蘋果，但一經烹調，便搖身變為可口無比的珍饈。酥炸過的茄子會散發美妙的奶油香味，灑些甜中帶辣的香料，風味絕佳。無論是燉煮或烘烤，茄子那種菇蕈般的麝香氣味，都能與鹹味食材完美搭配。除了偷偷咬一小口的方式外，檢查茄子是否具有所需風味與質地最好的方法，就是測試它的緊實度。一顆理想的茄子，外觀應該要像海豚皮膚般緊實光亮，用手揉捏時，還會發出嘎吱嘎吱的聲響。」',
        question: '根據本文，下列關於茄子的風味介紹，何者在文中沒有被提及？',
        options: [
            { text: 'A. 食用口感', },
            { text: 'B. 調味搭配', },
            { text: 'C. 適用醬汁', correct: true },
            { text: 'D. 測試方式', },
        ],
        background: '#F8FAFB'
    }, {
        id: 6,
        type: '選擇題',
        text: '6.<br/>「每個人都會在人世中遭遇一些坎坷，我們的身心都可能傷痕累累，但，那也是我們學習的功課。」',
        question: '作者這段文字的意義最接近下列何者?',
        options: [
            { text: 'A. 因為人世中總會遇到一些坎坷，所以身心受創是無法避免的。', },
            { text: 'B. 唯有精進學業，才能以堅毅的心迎戰人世中不可預期的坎坷。', },
            { text: 'C. 雖然人生的坎坷境遇會打擊我們，卻也是我們要面對的挑戰。' , correct: true },
            { text: 'D. 即便作好萬全準備，遭遇坎坷時仍會給身心帶來巨大的傷害。', },
        ],
        background: '#F8FAFB'

    }, {
        id: 7,
        type: '選擇題',
        text: '7.<br/>「一個項目成功與否，有 60%以上的因素取決於是否能以數行到一頁之間的長度陳述其核心想法，這也是所有業界人士是否願意青睞，考慮要不要繼續看下去的關鍵。」',
        question: '根據本段文字，推論業界人士最需要的是哪一項能力？',
        options: [
            { text: 'A. 高效搜集和整理大量資料的技巧' },
            { text: 'B. 簡潔與精準表達中心觀點的能力', correct: true },
            { text: 'C. 快速撰寫與解讀長篇文章的技能' },
            { text: 'D. 具備創意思維和問題解決的能力' },
        ],
        background: '#F8FAFB'
    }, {
        id: 8,
        type: '選擇題',
        text: '8.<br/>「王先生是一位享譽國際的畫家，正忙著準備今天的演講稿。去年，他再度榮獲世界繪畫大獎，讓他躍上了事業巔峰。其實，他並非從小就展現繪畫天分，他曾在課堂上多次被老師訓斥。想起那段往事後，王先生微微一笑，拿起筆，繼續修改眼前的講稿。」',
        question: '關於這段文字的寫作結構，下列分析何者正確?',
        options: [
            { text: 'A. 全文依照時間發生的先後，一步步交代王先生的奮鬥過程。' },
            { text: 'B. 採用倒敘法，先寫王先生事業成功，再說明他成名的原因。' },
            { text: 'C. 文末補充王先生微微一笑，是為了讓讀者掌握主角的心境，屬補敘法。' },
            { text: 'D. 在敘述當下準備演講的過程中，暫時切入小時候的往事，屬於插敘法。', correct: true }
        ],
        background: '#F8FAFB'
    }
]